export enum LocationCategory {
  RESTAURANT = 'RESTAURANT',
  WAREHOUSE = 'WAREHOUSE',
  PAID = 'PAID',
}
